import { appHttpService } from '@/services/standard/http-service';
import { models } from 'cesg-shared';

class LiftPlanUEService {
  async list(projectId: string): Promise<models.GetLiftPlanUEResponse> {
    return appHttpService.request
      .url(`/projects/${projectId}/lift-plan-ue`)
      .get()
      .json<models.GetLiftPlanUEResponse>();
  }

  async create(projectId: string): Promise<models.domain.LiftPlanUE> {
    return appHttpService.request
      .url(`/projects/${projectId}/lift-plan-ue`)
      .post()
      .json<models.domain.LiftPlanUE>();
  }

  async put(
    projectId: string,
    liftPlanId: string,
    body: models.PutLiftPlanUEBody,
  ): Promise<models.domain.LiftPlanUE> {
    return appHttpService.request
      .url(`/projects/${projectId}/lift-plan-ue/${liftPlanId}`)
      .put(body)
      .json<models.domain.LiftPlanUE>();
  }

  async delete(projectId: string, liftPlanId: string): Promise<void> {
    await appHttpService.request
      .url(`/projects/${projectId}/lift-plan-ue/${liftPlanId}`)
      .json({})
      .delete()
      .res();
  }
}

export const liftPlanUEService = new LiftPlanUEService();
